export const version = '1.21.3';
//# sourceMappingURL=version.js.map